module.exports = __webpack_public_path__ + "assets/talent-1dc08c8549cd66cb1b954bd1f8161762.svg";